import React from 'react';
import { View, Text, TouchableOpacity, ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { CityDistrictSelect } from './CityDistrictSelect';
import { ModalBottomSheet } from './ModalBottomSheet';
import type { SearchLocationTheme } from '../hooks/useSearchLocationFilter';

type Props = {
  visible: boolean;
  theme: SearchLocationTheme;
  title: string;
  city: string;
  district: string;
  onCityChange: (v: string) => void;
  onDistrictChange: (v: string) => void;
  onApply: () => void;
  onClose: () => void;
};

export function SearchLocationPickerModal({
  visible,
  theme,
  title,
  city,
  district,
  onCityChange,
  onDistrictChange,
  onApply,
  onClose,
}: Props) {
  const insets = useSafeAreaInsets();
  const canApply = Boolean(city.trim());

  return (
    <ModalBottomSheet visible={visible} onRequestClose={onClose} keyboardAvoiding>
      <View
        className="max-h-[88%] rounded-t-3xl border border-zinc-200 bg-white px-6 pt-5 dark:border-zinc-800 dark:bg-zinc-900"
        style={{ paddingBottom: 16 + insets.bottom }}>
          <View className="mb-4 h-1 w-10 self-center rounded-full bg-zinc-200 dark:bg-zinc-700" />
          <Text className="mb-1 text-lg font-bold text-zinc-900 dark:text-zinc-100">{title}</Text>
          <Text className="mb-5 text-xs leading-5 text-zinc-500 dark:text-zinc-400">
            Seçim yalnızca bu ekrandaki listeyi filtreler; profilindeki adresin değişmez.
          </Text>
          <ScrollView keyboardShouldPersistTaps="handled" showsVerticalScrollIndicator={false}>
            <CityDistrictSelect
              city={city}
              district={district}
              onCityChange={onCityChange}
              onDistrictChange={onDistrictChange}
              theme={theme}
            />
            <View className="mt-4 flex-row gap-3 pb-2">
              <TouchableOpacity
                onPress={onClose}
                className="flex-1 rounded-2xl border border-zinc-200 bg-white py-3.5 dark:border-zinc-700 dark:bg-zinc-800">
                <Text className="text-center font-semibold text-zinc-700 dark:text-zinc-200">
                  Vazgeç
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                disabled={!canApply}
                onPress={onApply}
                className={`flex-1 rounded-2xl border py-3.5 ${
                  canApply
                    ? 'border-zinc-900 bg-zinc-900 dark:border-zinc-50 dark:bg-zinc-50'
                    : 'border-zinc-200 bg-zinc-200 dark:border-zinc-800 dark:bg-zinc-800'
                }`}>
                <Text
                  className={`text-center font-semibold ${
                    canApply ? 'text-white dark:text-zinc-950' : 'text-zinc-400 dark:text-zinc-500'
                  }`}>
                  Uygula
                </Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </View>
    </ModalBottomSheet>
  );
}
